import { render, staticRenderFns } from "./DeskDeliveryGroup.vue?vue&type=template&id=1f346c73&"
import script from "./DeskDeliveryGroup.vue?vue&type=script&lang=ts&"
export * from "./DeskDeliveryGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports